import request from '@/utils/request'

export function getBaseInfo() {
    return request({
        url: '/api/common/setting/other',
        method: 'get',
    })
}
